export default __webpack_public_path__ + "static/media/Asset190.0d9e4c5e.svg";